
import { filter } from "lodash";

const getNotesAttachmentCounts = (notes, attachments, authentication) => {
  let notesLength = notes ? notes.length : 0;
  let attachmentsLength = attachments ? attachments.length : 0;

  if (authentication.isGuest) {
    const publicNotes = filter(notes, n => !n.isPrivate);
    notesLength = publicNotes.length;
    const publicAttachments = filter(attachments, a => !a.isPrivate);
    attachmentsLength = publicAttachments.length;
  }

  return { notesLength, attachmentsLength };
};

export default {
  getNotesAttachmentCounts
};
